<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M0 1.86655V9.56655C0 10.3254 0.6412 10.9666 1.4 10.9666H3.26667V13.2999C3.26667 13.3963 3.32593 13.4828 3.41577 13.5176C3.4433 13.5283 3.47177 13.5332 3.5 13.5332C3.5644 13.5332 3.6274 13.5066 3.67267 13.4569L5.93647 10.9666H12.6C13.3588 10.9666 14 10.3254 14 9.56655V1.86655C14 1.10775 13.3588 0.466553 12.6 0.466553H1.4C0.6412 0.466553 0 1.10775 0 1.86655ZM9.33333 5.59989C9.33333 5.08515 9.75193 4.66655 10.2667 4.66655C10.7814 4.66655 11.2 5.08515 11.2 5.59989C11.2 6.11462 10.7814 6.53322 10.2667 6.53322C9.75193 6.53322 9.33333 6.11462 9.33333 5.59989ZM6.06667 5.59989C6.06667 5.08515 6.48527 4.66655 7 4.66655C7.51473 4.66655 7.93333 5.08515 7.93333 5.59989C7.93333 6.11462 7.51473 6.53322 7 6.53322C6.48527 6.53322 6.06667 6.11462 6.06667 5.59989ZM2.8 5.59989C2.8 5.08515 3.2186 4.66655 3.73333 4.66655C4.24807 4.66655 4.66667 5.08515 4.66667 5.59989C4.66667 6.11462 4.24807 6.53322 3.73333 6.53322C3.2186 6.53322 2.8 6.11462 2.8 5.59989Z"
        fill="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: "IconChat"
}
</script>